<div class="modal-header">
    <h5 class="modal-title">{{ isEdit ? 'Editar Descuento de Usuario' : 'Agregar Descuento a Usuario'
        }}</h5>
    <button type="button" class="btn-close" aria-label="Cerrar" (click)="setCloseModal()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="discountForm">
        <!-- Seleccionar user -->
        <div *ngIf="isEdit==false" class="mb-3">
            <label for="selectUser" class="form-label">Usuario</label>
            <select id="selectUser" class="form-select" formControlName="userId">
                <option *ngFor="let user of users" [value]="user._id">
                    {{ user.name }}
                </option>
            </select>
        </div>

        <!-- Seleccionar Periodo -->
        <div *ngIf="isEdit==false" class="mb-3">
            <label for="selectPeriod" class="form-label">Periodo</label>
            <select id="selectPeriod" class="form-select" formControlName="periodId">
                <option value="" disabled selected>Seleccione un periodo</option>
                <option *ngFor="let period of periods" [value]="period._id">
                    {{ period.name }}
                </option>
            </select>
            <small *ngIf="discountForm.get('periodId')?.invalid && discountForm.get('periodId')?.touched"
                class="text-danger">Seleccione un periodo.</small>
        </div>


        <div class="mb-3">
            <label for="selectConcept" class="form-label">Motivo</label>
            <input type="text" name="" id="" class="form-control" formControlName="title">
            <small *ngIf="discountForm.get('title')?.invalid && discountForm.get('title')?.touched"
                class="text-danger">Ingrese el motivo.</small>
        </div>

        <div class="mb-3">
            <label for="inputDescription" class="form-label">Descripción (Opcional)</label>
            <textarea id="inputDescription" class="form-control" formControlName="description"></textarea>
        </div>

        <div class="mb-3">
            <label for="inputVote" class="form-label">Voto</label>
            <input type="text" id="inputVote" class="form-control" formControlName="vote">
        </div>

        <div class="mb-3">
            <label for="inputValue" class="form-label">Valor</label>
            <input type="number" id="inputValue" class="form-control" formControlName="value">
            <small *ngIf="discountForm.get('value')?.invalid && discountForm.get('value')?.touched"
                class="text-danger">Ingrese un valor</small>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="saveDiscount()">
                {{ isEdit ? 'Actualizar' : 'Guardar' }}
            </button>
            <button type="button" class="btn btn-secondary" (click)="setCloseModal()">Cancelar</button>
        </div>
    </form>
</div>